import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AngularPaths } from '@models/index.model';
import { NavigateService } from '@utils/navigate.service';

@Injectable({providedIn: 'root'})
export class PasswordUpdateGuard  {
  constructor(private _router: Router, private _navigate: NavigateService) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this._navigate.getParams(this._router)?.update) {
      return this._router.parseUrl(AngularPaths.DEFAULT);
    }

    return true;
  }
}
